/* eslint-disable max-lines */
import { STRIPE_GATEWAY_ID } from '@constants/index';
import { HOST_TYPE } from '@utils/api-helper/host';
import { subscriptionTypes } from '../constants';

export const fetchPricings =
  (
    uid,
    isIconic = false,
    // eslint-disable-next-line no-unused-vars
    isUpgrade = false,
    noCache = false
  ) =>
  (dispatch) => {
    const timeParam = noCache ? `&time=${Date.now()}` : '';
    return dispatch({
      type: subscriptionTypes.FETCH_PRICINGS,
      endpoint: `v3/subscriptions/?goal=${uid}&v=3&iconic=${isIconic}&upgrade=true${timeParam}`,
      method: 'get',
      uid
    });
  };

export const validateReferralAll =
  (
    referral,
    goal,
    scheme = 2,
    isIconic = false,
    // eslint-disable-next-line no-unused-vars
    isUpgrade = false
  ) =>
  (dispatch) =>
    dispatch({
      type: subscriptionTypes.VALIDATE_REFERRAL,
      endpoint: `v2/subscriptions/validate_referral_all_subscriptions/?referral=${encodeURIComponent(
        referral
      )}&goal=${goal}&iconic=${isIconic}&upgrade=true&scheme=${scheme}&v=3`,
      method: 'get',
      uid: goal,
      referral
    });

export const validateReferral =
  (
    referral,
    subscriptionId,
    goalId,
    scheme = 2,
    isIconic = false,
    // eslint-disable-next-line no-unused-vars
    isUpgrade = false
  ) =>
  (dispatch) =>
    dispatch({
      type: subscriptionTypes.VALIDATE_REFERRAL_SUBSCRIPTION,
      endpoint: `v2/subscriptions/validate_referral/?&iconic=${isIconic}&upgrade=true`,
      method: 'post',
      data: {
        referral,
        subscription: subscriptionId,
        scheme
      },
      uid: goalId,
      referral
    });

export const fetchEMIPlans = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_EMI_PLANS,
    endpoint: 'v1/payments/emi_plans/?version=2',
    method: 'get'
  });

export const fetchPartPaymentStatus = (goalUid) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_PART_PAYMENT_STATUS,
    key: goalUid,
    endpoint: `v1/subscriptions/pay_in_parts_subscription_details?goal_uid=${goalUid}`,
    method: 'get'
  });

export const enrollOrderStripe =
  (
    subscriptionId,
    creditsApplied,
    phoneNumber,
    referralCode,
    paymentMethod,
    paymentMethodType,
    emiData,
    gateway = 2,
    isPartial = false,
    parts = 0,
    subscription,
    cancelUrl,
    isCombo,
    comboId,
    comboName,
    referralError,
    selectedMethod,
    purchaseType,
    cashBank,
    cardType,
    paramsForReturnUrl
  ) =>
  (dispatch) =>
    dispatch({
      type: subscriptionTypes.ENROLL_ORDER,
      endpoint: `v1/subscriptions/order/${subscriptionId}/`,
      method: 'post',
      data: {
        renew: false,
        referral: referralCode || null,
        phone: phoneNumber,
        scheme: 2,
        use_credits: creditsApplied,
        payment_method: paymentMethod,
        payment_method_type: paymentMethodType,
        emi_data: emiData,
        gateway,
        upgrade: true,
        is_partial: isPartial,
        no_of_installments: parts,
        params_for_return_url: paramsForReturnUrl,
        return_url: process.env.STRIPE_PAYMENT_RETURN_URL,
        cancel_url: cancelUrl,
        bank_name: cashBank
      },
      isCashPayment: gateway === 8
    });

export const purchaseSubscription =
  (orderId, gateway = 2) =>
  (dispatch) => {
    const payload = {
      order_id: orderId,
      renew: false,
      gateway
    };
    if (gateway === STRIPE_GATEWAY_ID) {
      payload.session_id = orderId;
      payload.order_id = undefined;
    }
    return dispatch({
      type: subscriptionTypes.PURCHASE_SUBSCRIPTION,
      endpoint: 'v1/subscriptions/purchase/',
      method: 'post',
      data: payload
    });
  };

export const checkForPaymentStatusJuspay =
  (orderId, gateway = 'juspay', isStripe = false) =>
  (dispatch) =>
    dispatch({
      type: subscriptionTypes.PAYMENT_STATUS_JUSPAY,
      endpoint: `v1/payments/${gateway}/payment_status/?${
        isStripe ? 'session_id' : 'order_id'
      }=${orderId}`,
      method: 'get'
    });

export const savePurchasedSubscription =
  (goalOrComboId, orderId, purchasedSubscription) => (dispatch) =>
    dispatch({
      type: subscriptionTypes.SAVE_PURCHASED_SUBSCRIPTION,
      goalOrComboId,
      orderId,
      purchasedSubscription
    });

export const subscribeToExternalApp = (url, goalUID) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.ACTIVATE_EXTERNAL_APP,
    endpoint: url,
    key: goalUID,
    method: 'post'
  });

export const stopPartPaymentNudges = (subscriptionId) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.STOP_PART_PAYMENT_NUDGE,
    endpoint: `v1/users/visit_screen/part_payment_refund_screen/${subscriptionId}/`,
    method: 'post'
  });

export const activateExternalSubscription =
  (code, state, app_name) => (dispatch) =>
    dispatch({
      type: subscriptionTypes.SYNC_CODE_CHEF,
      endpoint: 'v1/subscriptions/activate_external_subscription',
      data: {
        code,
        state,
        app_name
      },
      method: 'post'
    });

export const fetchBundleDetails = (uid) => ({
  type: subscriptionTypes.FETCH_BUNDLE_DETAILS,
  uid,
  method: 'get',
  endpoint: `v1/subscriptions/bundle/${uid}/details`
});

export const fetchOfferList = (uid) => {
  return {
    type: subscriptionTypes.FETCH_OFFER_LIST,
    uid,
    endpoint: `v2/subscriptions/offer/list/?goal_uid=${uid}`,
    method: 'get'
  };
};

export const fetchOfferFaqs = () => ({
  type: subscriptionTypes.FETCH_OFFER_FAQS,
  endpoint: 'subscription-faqs/Offers-FAQ',
  method: 'get',
  hostType: HOST_TYPE.CMS
});

export const fetchCheckoutStaticData = (key) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_SUBSCRIPTION_STATIC_DATA,
    endpoint: `checkout-static-data/${key}`,
    key,
    method: 'get',
    hostType: HOST_TYPE.CMS
  });

export const fetchComboFeatures = (goalUIDs = []) => {
  const goal_uid_string = goalUIDs
    .map((goal) => `goalUID_in=${goal}&`)
    .join('');
  return {
    type: subscriptionTypes.FETCH_COMBO_FEATURE_POINTS,
    endpoint: `api/combo-goal-properties?${goal_uid_string}`,
    method: 'get',
    hostType: HOST_TYPE.CMS
  };
};

export const fetchCashPaymentStatus = (goalUID) => ({
  type: subscriptionTypes.FETCH_CASH_PAYMENT_DATA,
  endpoint: `v1/subscriptions/cash_payment_subscription_details/?goal_uid=${goalUID}`,
  method: 'get'
});

export const fetchBatchGroupSubscriptionInfo = (
  orderId,
  contentTypeId,
  objectId
) => {
  return {
    type: subscriptionTypes.FETCH_BATCH_GROUP_SUBSCRIPTION_INFO,
    endpoint: `v1/user/confirm_payment/?content_type_id=${contentTypeId}&object_id=${objectId}&order_id=${orderId}`,
    method: 'get'
  };
};
